export default __webpack_public_path__ + "static/media/GUIÓN SIMULADOR PUNCIÓN_2.7b8e4ebf.mp3";